function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#ff5252;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "AWS-Certificate-Manager_Certificate-Manager_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M47.5,46.62H42.81v-2H46.5l0-33.62H3.5V44.62H33.44v2H2.5a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1h45a1,1,0,0,1,1,1l0,35.62a1,1,0,0,1-1,1Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M47.45,11H2.5a1,1,0,0,1-1-1V4.38a1,1,0,0,1,1-1h45a1,1,0,0,1,1,1V10A1,1,0,0,1,47.45,11ZM3.5,9h43V5.38H3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M25,32.56a9.44,9.44,0,1,1,9.44-9.44A9.45,9.45,0,0,1,25,32.56Zm0-16.87a7.44,7.44,0,1,0,7.44,7.43A7.44,7.44,0,0,0,25,15.69Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M29.69,42.88a1,1,0,0,1-.64-.23L25,39.33,21,42.65a1,1,0,0,1-1.64-.77V33.44h2v6.32l3.06-2.49a1,1,0,0,1,1.26,0l3.06,2.49V33.44h2v8.44a1,1,0,0,1-.57.9A1.12,1.12,0,0,1,29.69,42.88Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M23.44,27.88a1,1,0,0,1-.73-.32l-3.12-3.28L21,22.9l2.4,2.52L29,19.62,30.41,21l-6.25,6.56A1,1,0,0,1,23.44,27.88Z"
}));

var SvgAwsAcmCertificate = function SvgAwsAcmCertificate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsAcmCertificate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-ACM_Certificate.7687e49e.svg";
export { ForwardRef as ReactComponent };